export function maskMobile(mobile?: string | null): string {
  const m = mobile ?? "";
  if (m.length < 5) return m;
  return `${m.slice(0, 5)}${"X".repeat(Math.max(0, m.length - 5))}`;
}

export function formatSavedAgo(saved: Date, now: number = Date.now()): string {
  const secs = Math.max(0, Math.floor((now - saved.getTime()) / 1000));
  if (secs < 5) return "just now";
  if (secs < 60) return `${secs}s ago`;
  const mins = Math.floor(secs / 60);
  if (mins < 60) return `${mins}m ago`;
  const hrs = Math.floor(mins / 60);
  return `${hrs}h ago`;
}

export function formatSavedAgoLabel(
  saved: Date,
  now: number = Date.now(),
): string {
  return `Saved · ${formatSavedAgo(saved, now)}`;
}
